export const environment = {
  production: true,
  SERVER_API_URL: 'https://aps-dev.acushnetgolf.com/socx',
  BRAND_LOGOS_URL: 'https://d1ld5niwlbjhja.cloudfront.net/fileshare/logos/',
  KITBUILDER_SCRIPT_URL:
    'https://api-test.kitbuilder.co.uk/api/Bootstrapper?distributorId=96724771&key=7c3e4eaabf04454c9133021c792a5598',
  DRIVE_COMMERCE_SCRIPT_URL: 'https://build.drrv.co/stg-acushnet-b2b/widget/latest/customizerwidget.umd.js',
  DRIVE_COMMERCE_API_KEY: 'pXYpFaDHhIyfRcSO5thOC8uS5nfad65P0cIrtcTd74gkxirfE4sLuqpUcpaBKz5mJXzeCGHsVqjRGrjLcZ1QyGTFMphPcgXj',
  GA_TRACKINGID: 'G-ZENYYWRVB2',
};
